module.exports = __webpack_public_path__ + "static/media/leaf-youth-thumb.c27b0d73.png";